<template>
  <div class="main">
    <Result
      :error="true"
      :title="this.$route.query?.title.toString()"
      :description="t('PAYJOY_CARD_VIEWS.CC_ERROR')"
      :btn-text="t('CL_WITHDRAWAL.GO_TO_HOME_BTN')"
      @dismissFunc="dismiss()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Result from "@/apps/credit-line/components/Result.vue";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
declare const Android: AndroidInterface;
export default defineComponent({
  name: "CreditLineErrorView",
  components: { Result },
  methods: {
    dismiss() {
      return Android.dismissWebView();
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  mounted() {
    Android.finishedLoading();
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";
</style>
